import React, { useState, Fragment } from 'react'
import './Index.css'
import NavbarItem from '../index/navbarItem/NavbarItem'
import config from '../../../routes/navbarConfig'
import logo from '../../../assets/img/logo.svg'
import {
    getUserFullname,
    isAuthenticated,
} from '../../../services/authenticationChecker'
import Tour from 'reactour'
import Button from 'reactstrap/lib/Button'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { drawForHelpTour } from '../../../redux/tools/actions'
import classNames from 'classnames'

const Index = ({ isPlan, isPayment, ...props }) => {
    const [isTourOpen, setIsTourOpen] = useState(false)
    const [currentStep, setCurrentStep] = useState(0)

    const toggleTourStatus = () => {
        setIsTourOpen(!isTourOpen)
        setCurrentStep(0)
    }

    const dispatch = useDispatch()

    const tourFooter = (goTo, nextPage) => (
        <div className="footer-container">
            <Button
                className="next-btn"
                size="sm"
                color="link"
                onClick={() => goTo(nextPage)}
            >
                بعدی
            </Button>
            <Button
                className="later-btn"
                size="sm"
                color="link"
                onClick={() => restartTourStatus(goTo)}
            >
                بعدا میبینم
            </Button>
        </div>
    )

    const finalTourFooter = (goTo) => (
        <div className="footer-container">
            <Button
                className="next-btn"
                size="sm"
                color="link"
                onClick={() => restartTourStatus(goTo)}
            >
                اتمام
            </Button>
        </div>
    )

    const restartTourStatus = (goTo) => {
        toggleTourStatus()
        goTo(0)
    }

    const steps = [
        {
            selector: '.nav.nav-tabs .nav-item:last-child a',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">1</span>
                        بر روی اتاق‌ها کلیک کنید
                    </p>
                    {tourFooter(goTo, 1)}
                </Fragment>
            ),
            action: (node) => {
                if (node && node.focus) {
                    node.focus()
                    node.click()
                }
            },
            stepInteraction: false,
        },
        {
            selector: '.room-card.card',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">2</span>
                        اتاق را انتخاب کنید
                    </p>
                    {tourFooter(goTo, 2)}
                </Fragment>
            ),
            action: (node) => {
                if (node && node.focus) {
                    node.focus()
                    node.click()
                }
            },
            stepInteraction: false,
        },
        {
            selector: '.nav.nav-tabs .nav-item a',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">3</span>
                        بر روی پارچه‌ها کلیک کنید
                    </p>
                    {tourFooter(goTo, 3)}
                </Fragment>
            ),
            action: (node) => {
                if (node && node.focus) {
                    node.focus()
                    node.click()
                }
            },
            stepInteraction: false,
        },
        {
            selector: '.material-item-wrapper',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">4</span>
                        پارچه مورد نظر را انتخاب نموده و بر روی ناحیه دلخواه در
                        تصویر کشیده و رها کنید
                    </p>
                    {tourFooter(goTo, 4)}
                </Fragment>
            ),
            stepInteraction: false,
        },
        {
            selector: '#scene-container',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">5</span>
                        برای ایجاد تغییراتی از قبیل روشنایی و بزرگنمایی ابتدا
                        ناحیه مورد نظر را انتخاب کنید
                    </p>
                    {tourFooter(goTo, 5)}
                </Fragment>
            ),
            action: () => {
                dispatch(drawForHelpTour())
            },
            position: 'right',
            stepInteraction: false,
        },
        {
            selector: '.mini-editor',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">6</span>
                        امکان تغییر کنتراست، بزرگنمایی، روشنایی و غیره وجود دارد
                    </p>
                    {tourFooter(goTo, 6)}
                </Fragment>
            ),
            stepInteraction: true,
        },
        {
            selector: '.download-btn',
            content: ({ goTo }) => (
                <Fragment>
                    <p className="tour-content">
                        <span className="tour-number">7</span>
                        پس از ایجاد تغییرات و نهایی شدن طرح، با کلیک بر روی
                        دانلود، عکس طرح ذخیره خواهد شد
                    </p>
                    {finalTourFooter(goTo)}
                </Fragment>
            ),
            stepInteraction: true,
        },
    ]

    return (
        <div
            className={classNames('navbar-container', {
                'navbar-container--payment': isPayment,
            })}
        >
            <Link to="/" className="logo-container">
                <img className="logo" src={logo} alt="" />
            </Link>
            <Tour
                steps={steps}
                isOpen={isTourOpen}
                disableDotsNavigation={true}
                showNumber={false}
                showButtons={false}
                showCloseButton={false}
                goToStep={currentStep}
                onRequestClose={toggleTourStatus}
                rounded={8}
            />
            <ul className="d-flex align-items-center">
                {isAuthenticated && (
                    <Link to={{ pathname: '/', search: '?type=my' }}>
                        <li className="user-name">{getUserFullname()}</li>
                    </Link>
                )}
                {config
                    .filter((q) => (!isPayment && !isPlan) || !q.isEditorOnly)
                    .map((item, index) => {
                        return <NavbarItem key={index} {...item} />
                    })}
                {!isPayment && !isPlan && isAuthenticated && (
                    <li className="help-tour" onClick={toggleTourStatus}>
                        راهنمای استفاده
                    </li>
                )}
            </ul>
        </div>
    )
}

export default Index
